import { createFileRoute } from '@tanstack/react-router';

import { parseConversationsSearch } from '../../../conversations/search.js';
import { UsersPage } from '../../../users/UsersPage.js';

/**
 * `/account/users` (users-and-permissions `technical.md`, Dashboard). The page
 * number lives in the URL (`patterns/ui-patterns.md`, 6), parsed the same way
 * as the other paginated lists: anything that isn't a whole number from 1 up is
 * page 1.
 */
export const Route = createFileRoute('/_app/account/users')({
  validateSearch: parseConversationsSearch,
  component: UsersRoute,
});

function UsersRoute() {
  const { page = 1 } = Route.useSearch();
  return <UsersPage page={page} />;
}
